'use strict';

/**
 * View for rendering the main list of manage storeages
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollectionView = require('base/Colido.CollectionView');
var ManageStorageListItemView = require('./manage-storage-list-item');

var ManageStorageList = ColidoCollectionView.extend({
    childView: ManageStorageListItemView,
    tagName: 'ol',
    className: 'dd-list',
    sortDefault: 'sortOrder.asc-name.asc',
});

module.exports = ManageStorageList;